import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { CSRFTokenRequest, IUserDetails } from '../../../entity';

export interface IInternalVerifyUserUseCase {
    execute(username: string, recaptchaToken: string, csrfToken: CSRFTokenRequest): Promise<IUserDetails[]>;
}

export class InternalVerifyUserUseCase implements IInternalVerifyUserUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(username: string, recaptchaToken: string, csrfToken: CSRFTokenRequest): Promise<IUserDetails[]> {
        const user = await this.userRepo.internalVerifyUser(username, recaptchaToken, csrfToken);
        if (user.data?.userDetails) {
            return user.data.userDetails;
        }
        return [];
    }
}
